export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';
export const FETCH_WORK_ROLES = 'FETCH_WORK_ROLES';
export const FETCH_DEPARTMENT_COUNT = 'FETCH_DEPARTMENT_COUNT';
export const FETCH_WORK_ROLES_COUNT = 'FETCH_WORK_ROLES_COUNT';
export const FETCH_ALL_DEPARTMENTS = 'FETCH_ALL_DEPARTMENTS';
export const FETCH_ALL_WORK_ROLES = 'FETCH_ALL_WORK_ROLES';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_SEARCH_WORKROLES = 'SET_SEARCH_WORKROLES';
